const colors = require("tailwindcss/colors");

module.exports = {
  purge: [],
  darkMode: false, // or 'media' or 'class'
  theme: {
    fontFamily: {
      display: ["Comfortaa"],
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      palette1: "#8ECAE6",
      palette2: "#219EBC",
      palette3: "#023047",
      palette4: "#FFB703",
      palette5: "#FB8500",
      white: "white",
      gray: colors.gray,
      background: "white",
      warning: "#fcb479",
      orange: "#fc9a79",
      error: "#b54568",
      yellowGreen: "#a0b581",
      success: "#81b58f",
    },
    extend: {
      transitionTimingFunction: {
        "in-expo": "cubic-bezier(0.95, 0.05, 0.795, 0.035)",
        "out-expo": "cubic-bezier(0.19, 1, 0.22, 1)",
      },
      keyframes: {
        wiggle: {
          "0%": { transform: "translateX(0em)" },
          "10% ": { transform: "translateX(-0.5em)" },
          "20%": { transform: "translateX(0.5em)" },
          "30%": { transform: "translateX(0em)" },
          "100%": { transform: "translateX(0em)" },
        },

        float: {
          "0%": { transform: "translateY(0.3rem)" },
          "50%": { transform: "translateY(-0.3rem)" },
          "100%": { transform: "translateY(0.3rem)" },
        },
      },
      animation: {
        wiggle: "wiggle 2s ease-in-out infinite",
        float: "float 5s ease-in-out infinite",
      },
    },
  },
  variants: {
    extend: {
      backgroundColor: ["odd"],
      opacity: ["disabled"],
    },
  },
  plugins: [],
};
